<template>
  <div class="page-modal">
    <!-- Single -->
    <widgetModal title="Assignment" subtitle="This is a list matched and applied Assignment" btnlefttext="Close"
      btncentertext="" btnrighttext="" :leftloading="false" :rightloading="false" :centerloading="false"
      :footerhidden="false" footer_padding="10px 18px 30px 30px" header_padding="30px 0px 0px 31px"
      body_padding="30px 30px" width="550px" @onLeftClick="onCancel">
      <div class="widget-modal-body-noscoll">

      </div>
    </widgetModal>
  </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
  name: "page-modal",
  components: {
  },
  props: {
    user: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  mounted() {
    let vm = this;
  },
  methods: {
    onCancel() {
      let vm = this;
      vm.$emit("close", null);
    },
  },
};
</script>

<style lang="scss" scoped>
$assets: "~@/assets";

.page-modal {
  .widget-modal-body-noscoll {
    max-height: 500px;
    overflow-y: auto;

    .applied-internship {
      margin-bottom: 20px;
    }
  }
}
</style>